import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Erb } from '../models/erb.model';

@Injectable({
  providedIn: 'root',
})
export class ErbService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}


  public getErbs(erbs: Erb[]): Observable<Erb> {
    return this.http.post<Erb>(
      `${this.apiServerUrl}/erbs/search`,
      erbs,
      { withCredentials: true }
    );
  }
}
